import { initFederation } from '@angular-architects/native-federation';
import { environment } from './environments/environment';

type AngularDevModeGlobal = typeof globalThis & { ngDevMode?: boolean };

let manifestPath = '/assets/federation/federation.manifest.json';

if (environment.production) manifestPath = '/assets/federation/federation.manifest.prod.json';
else if (environment.test) manifestPath = '/assets/federation/federation.manifest.acp.json';
else if (environment.dev) manifestPath = '/assets/federation/federation.manifest.dev.json';

if (!environment.production) {
  (globalThis as AngularDevModeGlobal).ngDevMode ??= true;
}

initFederation(manifestPath)
  .then(() => import('./bootstrap'))
  .catch((err) => console.error(err));
